export const OrderStatus = Object.freeze({
  0: 'Pending',
  11: 'Cancelled',
  10: 'Completed',
});
